import { type AccommodationDetail } from '@/api/accommodation/types'
import { Typography } from '@/components/ui/typography'
import EquipmentCard from './EquipmentCard'
import SpaceCard from './SpaceCard'

interface DetailAmenitiesSectionProps {
  unit: AccommodationDetail['unit']
  locationFacility: AccommodationDetail['facility']
}

export function DetailAmenitiesSection({ unit, locationFacility }: DetailAmenitiesSectionProps) {
  return (
    <div id="amenities" className="scroll-mt-38 space-y-6 lg:scroll-mt-16">
      <Typography variant="h2">Co ubytování nabízí</Typography>
      <div className="space-y-4">
        {unit.spaces.length > 0 && (
          <div className="grid grid-cols-2 gap-2 lg:grid-cols-3">
            {unit.spaces.map((space, key) => (
              <SpaceCard key={key} space={space} />
            ))}
          </div>
        )}
        <EquipmentCard facility={unit.facility} locationFacility={locationFacility} />
      </div>
    </div>
  )
}
